import {FC, useEffect, useState} from "react";
import {Alert, Button, Container, Form, Navbar, Row, Spinner} from "react-bootstrap";
import PageHeader from "../../components/pageheader/pageheader";
import EditorJS from "@editorjs/editorjs";
import List from "@editorjs/list";
import {getPartyDetailsForUser} from "../../api/getbyparty";
import {addToParty, handleAddingToParty, updateGifts} from "../../api/addtoparty";
import {useNavigate} from "react-router-dom";
import LogoutButton from "../../components/logoutbutton/logoutbutton";
import {useAuth0} from "@auth0/auth0-react";
import _ from "lodash";

interface PortalProps {
    partyId: String
}

const Portal: FC<PortalProps> = ({ partyId }) => {  {

    const [firstName, setFirstName] = useState();
    const [lastName, setLastName] = useState();
    const [email, setEmail] = useState();
    const [matchedName, setMatchedName] = useState();
    const [giftList, setGiftList] = useState();

    const [variantType, setVariantType] = useState();
    const [showAlert, setShowAlert] = useState(false);
    const [message, setMessage] = useState();

    const [isLoading, setLoading] = useState(true);

    let editor = { isReady: false };
    let readOnlyEditor = { isReady: false };

    const { user, isAuthenticated } = useAuth0();

    const navigate = useNavigate();

    useEffect(() => {
        if (user) {
            setEmail(user.email);

            getPartyDetailsForUser(1, user.email).then(data => {
                if (!data) {
                    data = {}
                }

                setFirstName(data.FirstName);
                setLastName(data.LastName);

                setGiftList(data.Gifts);

                if (!editor.isReady) {
                    editor = new EditorJS({
                        id: "editor",
                        holder: "editorjs",
                        data: {
                            blocks:[{
                                type: 'list',
                                data: {
                                    style: 'ordered',
                                    items: data.Gifts,
                                },
                            }]
                        },
                        tools: {
                            list: {
                                class: List,
                                inlineToolbar: false,
                                config: {
                                    defaultStyle: 'ordered'
                                }
                            },

                            paragraph: false
                        },
                        onChange: (api, event) => {
                            editor.save().then((outputData) => {
                                const giftListBuilder = outputData.blocks.map((block) => {
                                    return block.data.items;
                                }).reduce((pre, cur) => {
                                    return pre.concat(cur);
                                });

                                setGiftList(giftListBuilder);
                            }).catch((error) => {
                                console.log('Saving failed: ', error)
                            });

                        }
                    });
                }

                const userReadInfo = data.AssignedUser;

                setMatchedName('No matches yet! Wait until Reinhardt mixes the list');
                if (!readOnlyEditor.isReady && userReadInfo.Email) {
                    setMatchedName('You are buying for: ' + userReadInfo.FirstName + ' ' + userReadInfo.LastName + '. Their gift list is:');
                    readOnlyEditor = new EditorJS({
                        holder: "matchedGiftList",
                        data: {
                            blocks:[{
                                type: 'list',
                                data: {
                                    style: 'ordered',
                                    items: userReadInfo.Gifts,
                                },
                            }]
                        },
                        tools: {
                            list: {
                                class: List,
                                inlineToolbar: true,
                                config: {
                                    defaultStyle: 'ordered'
                                }
                            }
                        },
                        readOnly: true
                    });
                }

            }).then(() => {
                setLoading(false);
            });
        }
    }, [user, isAuthenticated]);

    const submitForm = (event) => {
        event.preventDefault();

        if (_.isEmpty(event.target.elements.FirstName?.value) || _.isEmpty(event.target.elements.LastName?.value)) {
            setMessage("Please enter your first name and last name below");
            setVariantType('danger');
            setShowAlert(true);
            window.scrollTo(0,0);
        } else {
            const formDataObj = {
                PartyId: "1",
                FirstName: event.target.elements.FirstName?.value,
                LastName: event.target.elements.LastName?.value,
                Email: event.target.elements.Email?.value,
                Gifts: giftList
            }

            updateGifts(formDataObj).then(response => {
                if (response?.httpCode === '200') {
                    setMessage('Successfully Updated')
                    setVariantType('primary')
                    setShowAlert(true);
                    window.scrollTo(0,0);
                    console.log('Successfully updated')
                } else {
                    setMessage(response.message)
                    setVariantType('danger')
                    setShowAlert(true);
                    window.scrollTo(0,0);
                    console.log('Error updating');
                }
            });

        }
    }

    const logout = () => {
        window.sessionStorage.jwt = "";
        navigate("/");
    }

    return (
        <Container fluid="md">
            <Navbar bg="light" expand="lg">
                <Container>
                    <LogoutButton className="logoutButton" onClick={() => logout()}>Logout</LogoutButton>
                </Container>
            </Navbar>
            <Alert key='login-error' variant={variantType} className='login-error' show={showAlert}>
                {message}
            </Alert>
            <Row>
                <div className="welcomeHeader"><PageHeader headerValue={'Secret Santa'} textSize={36}/></div>
            </Row>
            <Row>
                <div className="welcomeSubHeader"><PageHeader headerValue={'Registration Form'} textSize={18}/></div>
            </Row>
                <Row>
                    {isLoading &&
                        <Row>
                            <Spinner className="spinner" animation="border" role="status">
                                <span className="visually-hidden"></span>
                            </Spinner>
                            <span className="spinner">Loading...</span>
                        </Row>
                    }
                    <Form className="welcomeForm" onSubmit={submitForm}>
                        <h1>Your Info</h1>
                        <Form.Group className="mb-3" controlId="formFirstName">
                            <Form.Label>first name</Form.Label>
                            <Form.Control type="text" name="FirstName" placeholder="Enter first name" disabled={!_.isEmpty(firstName) || isLoading} value={firstName} required={true}/>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formLastName">
                            <Form.Label>last name</Form.Label>
                            <Form.Control type="text" name="LastName" placeholder="Enter last name" disabled={!_.isEmpty(lastName) || isLoading} value={lastName} required={true}/>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formEmail">
                            <Form.Label>e-mail</Form.Label>
                            <Form.Control type="text" name="Email" placeholder="Enter your e-mail" disabled={true} value={email}/>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formGiftTable">
                            <Button type="submit">Save Gifts</Button>
                            <div id="editorjs" />
                        </Form.Group>
                    </Form>
                    <Form className="welcomeForm">
                        <h1>Your Recipient</h1>
                        <Form.Group className="mb-3" controlId="formGiftTable">
                            { matchedName && <div className="welcomeSubHeader"><PageHeader headerValue={matchedName} textSize={18}/></div> }
                            <div id="matchedGiftList"/>
                        </Form.Group>
                    </Form>
                </Row>
        </Container>
    );

}}

export default Portal;